// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"6ad6db49","598":"b0771766","703":"8e2d9de1","787":"195ca89a"}[chunkId] + ".chunk.js";
};